<template>
    <div id="content" v-show="!loading">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction" />
        <form>
            <div class="inner">
                <p class="paging">
                    <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
                </p>
                <p class="buttons">
                    <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
                       @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
                </p>
                <h1 v-if="hasName">{{ entity.firstname }} {{ entity.surname }}
                    <span>{{ companyTown }}</span>
                </h1>
            </div>

            <div class="responsiveTabs r-tabs">
                <ul class="tabs">
                    <li :class="{ 'r-tabs-state-active': this.$route.name === 'billerDetail'}">
                        <a @click.prevent.stop="activateRoute('billerDetail')" v-translate>Vlastnosti</a>
                    </li>
                    <li :class="{ 'r-tabs-state-active': this.$route.name === 'billerDetailSubscribers'}" v-if="$_loggedUser_action_allowed('subscribers')">
                        <a @click.prevent.stop="activateRoute('billerDetailSubscribers')" v-translate>Odběratelé</a>
                    </li>
                    <li :class="{ 'r-tabs-state-active': this.$route.name === 'billerDetailServices'}" v-if="$_loggedUser_action_allowed('services')">
                        <a @click.prevent.stop="activateRoute('billerDetailServices')" v-translate>Služby</a>
                    </li>
                    <li :class="{ 'r-tabs-state-active': this.$route.name === 'billerDetailDevices'}" v-if="$_loggedUser_action_allowed('devices')">
                        <a @click.prevent.stop="activateRoute('billerDetailDevices')" v-translate>Zařízení</a>
                    </li>
                </ul>
            </div>

            <div class="responsiveTabs">
                <div class="tabs_content" v-if="this.$route.name === 'billerDetail'">
                    <section v-show="$_readActionAllowedAllOrOwnAndGlobal || !$_loggedUser_selectedOperatorId">
                        <div class="left">
                            <h2 v-translate>Výběr operátora</h2>
                        </div>
                        <div class="right">
                            <div class="field_left">
                              <operator-select
                                  v-model="entity.id_operator"
                                  :options="operatorOptions"
                                  :disabled="true"
                              >
                              </operator-select>
                            </div>
                        </div>
                    </section>
                    <section>
                        <div class="left">
                          <detail-entity-info
                              :entity="entity"
                          >
                            <p><translate>Počet odběratelů</translate>: <span class="date">{{ entity.subscribers_count }}</span></p>
                            <p v-if="!this.loading"><translate>Počet služeb</translate>: <span class="date">{{ entity.services.length }}</span></p>
                            <p v-if="!this.loading"><translate>Počet zařízení</translate>: <span class="date">{{ entity.devices.length }}</span></p>
                          </detail-entity-info>
                        </div>
                        <biller-form
                                :entity="entity"
                                :operator-options="operatorOptions"
                                :operator-disabled="true"
                                :ownId="ownId"
                                :isEditable="$_updateActionAllowed"
                                @own-id-change="setOwnId"
                                ref="billerformref"
                        ></biller-form>
                    </section>
                    <section class="buttons">
                        <p>
                            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
                            </router-link>
                            <input v-if="$_updateActionAllowed"
                                type="submit" :value="'Uložit' | translate"
                                   :class="['btn']"
                                   @click.prevent.stop="submitForm()">
                        </p>
                    </section>
                </div>
                <router-view v-else
                    class="tabs_content"
                    :biller="this.entity"
                    :loading="this.loading"
                />
            </div>
        </form>
    </div>
</template>

<script>
	import BillerForm from "@/components/views/billers/BillerForm"
	import detailActions from "@/components/mixins/detail-actions"
	import billers from "@/components/views/billers/mixins/billers"

	export default {
		name: "BillerDetail",
		components: {BillerForm},
		mixins: [detailActions, billers],
		created(BillerService, OperatorService) {
			this.entityService = BillerService
            this.operatorService = OperatorService
			this.createdInit()
            this.getOperators()
		},
		methods: {
			getEntity() {
				this.setLoadingMessage()

				return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(data => {
						this.entity = data.biller
						this.ownId = data.biller.id_remote
						this.emptyMessage()
					})
					.then(() => {
						this.$refs['billerformref'].validateBillerFormRequiredFields()
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
			updateEntity(params, redirect = false) {
				this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}))
					.then(() => {
						if (redirect === true) {
							this.redirect(this.moduleName)
						} else {
							this.emptyMessage()
							this.setSuccessMessage()
							this.getEntity()
						}
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error))
					}.bind(this))
			},
            activateRoute(routeName) {
                this.$router.push({
                    name: routeName
                });
            }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/billers/BillerDetail.vue